import dynamic from 'next/dynamic';
import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';
import {
  lotionFootnoteTable,
  productsToGenerateForBuild,
  productsToGenerateForTesting,
  ratingTableLotion,
} from '../../src/Constants/ProductPage';
import { SVGSourcePDP } from '../../src/Svg/ProductPage';
import { getActualPdpPath } from '../../src/Utils/PdpRedirectUrls';
import {
  getDiscussionJSONLdData,
  getExperimentalOfferData,
  getExperimentTypeOfUser,
  getRandomEventId,
  getReviewJSONLdData,
  getScreenName,
  getUserIsLoggedIn,
  getWebUserId,
  isAndroidAppUser,
} from '../../src/Utils/helper';
import {
  checkShowFaqs,
  fireScrollEvent,
  getFaqsHtmlData,
  PDPDiscussionData,
  useIsDesktop,
  useProductPageConstructor,
} from '../../src/Utils/productPageUtils';
import PDPHeadElements from '../../src/components/Product/PDPHeadElements';
import {
  BreadcrumbsCover,
  MainContainer,
} from '../../src/components/Product/PdpHeader/styled';
import WidgetsMerge from '../../src/components/Product/WidgetsMerge';
import Breadcrumbs from '../../src/components/StoreCategoryPage/Breadcrumbs';
import {
  checkProductSddNddEligiblity,
  discussionFetcher,
  productFetcher,
  reviewFetcher,
  useGetProductData,
} from '../../src/datafetchers/productPage';
import GlobalStyle from '../../src/styles/globalStylesV2';
import ImageGalleryStyle from '../../src/styles/imagegallery';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { getTitleFromUrl } from '../../src/Constants/StaticPages';
import { getCountry } from '../../src/Utils/ForeignUtils';
import {
  addProductToRecentltViewedSection,
  dynamicOpenDeepLink,
  fbFixelTrackEvent,
  fireConversionEvent,
  getFilteredProductData,
  getPriceFetcher,
  getProductIdfromUrl,
  isDesktopUser,
  updateOfferStripData,
} from '../../src/Utils/ProductUtils';
import { viewedAndroidLanding } from '../../src/Utils/ProductUtils/instrumentation';
import { revalidate_15_minutes } from '../../src/Utils/SEO/constants';
import { getSeoVisibility } from '../../src/appconfig';
import NewFooter from '../../src/components/HomePage/NewFooter';
import { getProductCategorySitemapData } from '../../src/datafetchers/ProductCategory';
import OfferStripHeader from '../../src/components/ArticlePage/OfferStripHeader';
import { diaperSkus } from '../../src/components/Product/OfferCarousel/constant';
import {
  checkEligibilityForSsoTooltip,
  showDiaperSwitch,
} from '../../src/Utils/commonUtils';
import FloatingVideo from '../../src/components/FloatingVideo/index';
import { lactoMamaPdp } from '../../src/components/Product/FertilityTrustSection/constant';
import { getWebUserType } from '../../src/Utils/getWebUserType';
import { fireUserLocationEvent } from '../../src/Utils/fireUserLocationEvent';
import { fireEvent } from '../../src/Utils/fireEvent';
import { productActionClick } from '../../src/Utils/productAction';
const KwikPassSsoTooltip = dynamic(
  () => import('../../src/components/KwikPassSsoTooltip'),
  {
    ssr: false,
  },
);
// import NewHeader from "../../../src/components/HomePage/NewHeader";
const Loader = dynamic(() => import('../../src/components/Loader'), {
  ssr: false,
});
const NewHeader = dynamic(
  () => import('../../src/components/HomePage/NewHeader'),
  {
    ssr: false,
  },
);

export async function getStaticPaths() {
  const buildIds = getSeoVisibility()
    ? productsToGenerateForBuild
    : productsToGenerateForTesting;

  return {
    paths: buildIds,
    fallback: 'blocking',
  };
}

export async function getStaticProps(context) {
  let id = decodeURIComponent(context.params.product);

  if (id.includes('?')) {
    return {
      redirect: {
        destination: `/product/${id}`,
        statusCode: 301,
      },
    };
  }
  // if urls contains undefined
  if (id.includes('undefined')) {
    const getPaths = getActualPdpPath(id.split('undefined')[0]);
    return {
      redirect: getPaths,
    };
  }

  id = getProductIdfromUrl(id);
  // if (id === "2631" || id === "2632") {
  //     return {
  //         redirect: {
  //             destination: `/product/stroller`,
  //             statusCode: 307,
  //         },
  //     };
  // }
  let productData = {};
  let reviewData = null;
  let offerList = null;
  let ReviewJSONLDData = [];
  let DiscussionJSONLDData = [];
  let discussionData = {};
  let user_review_images = [];
  let catUrls = [];
  // let cookieString = context.req.headers.cookie;
  // let userType = getCookieValue(cookieString, "experiment_type");
  // if (!userType) {
  //     userType = getRandomExperimentValue();
  //     context.res.setHeader(
  //         "Set-Cookie",
  //         `experiment_type=${userType}; Path=/;`,
  //     );
  // }
  try {
    productData = await productFetcher(`api/getProduct/${id}`);
    productData = getFilteredProductData(productData);
    productData.data.offers = null;
    reviewData = await reviewFetcher(id, true);
    discussionData = await discussionFetcher(id, true);
    const sitemapData = await getProductCategorySitemapData();
    catUrls = sitemapData?.data?.map((data) => data.url);

    DiscussionJSONLDData = getDiscussionJSONLdData(discussionData);
    const { ReviewJSONData } = getReviewJSONLdData(reviewData);
    user_review_images = reviewData?.data?.user_review_images;
    user_review_images = user_review_images?.map((item) => {
      return { image: item.image, count: user_review_images?.length };
    });
    ReviewJSONLDData = ReviewJSONData;
  } catch (error) {
    try {
      productData = await productFetcher(`api/getProduct/${id}`);
      reviewData = null;
      discussionData = null;
      ReviewJSONLDData = null;
      DiscussionJSONLDData = null;
    } catch (error) {
      const errorString = `Error generating page with ID: ${id}, ${error}`;
      if (error.response.status == '400' || error.response.status == '404') {
        return {
          notFound: true,
          revalidate: 60,
        };
      } else throw new Error(error);
    }
  }
  return {
    props: {
      productApidata: productData,
      productId: id,
      offerList: offerList,
      ReviewJSONLDData: ReviewJSONLDData,
      DiscussionJSONLDData: PDPDiscussionData[id] || DiscussionJSONLDData,
      reviewData: {},
      user_review_images: user_review_images
        ? user_review_images?.slice(0, 4)
        : [],
      catUrls: catUrls,
      // experimentUserType: userType,
    },
    revalidate: revalidate_15_minutes,
  };
}

export default function ProductPage(props) {
  const {
    productApidata,
    productId,
    offerList,
    ReviewJSONLDData,
    DiscussionJSONLDData,
    // reviewData,
    user_review_images,
    catUrls,
  } = props;

  const { updatedProductData, productMutate } = useGetProductData(
    productApidata,
    productId,
  );
  const videoRef = useRef(null);
  const [categoryNavBarTop, setCategoryNavBarTop] = useState(56);
  const oldScrollValue = useRef(0);
  const throttleTimeout = useRef(false);
  let productData = updatedProductData?.data;
  const categoryData = updatedProductData?.categories;
  const generalItemData = updatedProductData?.generalItemData;
  const bottomPageRef = useRef(null);
  const firedBottomPageEvent = useRef(false);
  const [showHeader, setShowHeader] = useState('-56px');
  const [showTop, setShowTop] = useState(false);
  const [visitedCD, setVisitedCD] = useState(false);
  const headerHidden = useRef(true); // true if we want to enable it before hand
  const [addedToCart, setAddedToCart] = useState(false);
  const [priceData, setPriceData] = useState(false);
  const [changeData, setChangeData] = useState(false);
  const [showLoader, setshowLoader] = useState(false);
  const [showBreadCrumbs, setShowBreadCrumbs] = useState(false);
  const [showTuesdayPopup, setShowTuesdayPopup] = useState(false);
  const [showLighteningDeal, setShowLighteningDeal] = useState(false);
  const [country, setCountry] = useState();
  const [userType, setUserType] = useState();
  const router = useRouter();
  const [changeCartCount, setChangeCartCount] = useState();
  const [experimentUserType, setExperimentUserType] = useState();
  const isDesktop = useIsDesktop();
  const [isFullScreenVideoEnabled, setIsFullScreenVideoEnabled] =
    useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isVideoVisible, setIsVideoVisible] = useState(false);
  const [showFullScreenVideo, setShowFullScreenVideo] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [sddNddData, setSddNddData] = useState(null);
  const [showSsoTooltipDot, setShowSsoTooltipDot] = useState(false);
  const [showSsoTooltip, setShowSsoTooltip] = useState(false);
  const [loginPopUp, setLoginPopUp] = useState(false);
  const showNewOfferStripUI = [1097, 3907, 3961].includes(productData?.id);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVideoVisible(true);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   if (typeof window !== 'undefined') {
  //     if (lactoMamaPdp.includes(productData?.id)) {
  //       router.replace(
  //         '/category/Increase-Breast-Milk-Supply-with-LactoMama-Lactation-Granules' +
  //           window.location.search,
  //       );
  //     }
  //   }
  // }, [router, productData?.id]);
  // useState(false);
  const bottomPageInteraction = useIntersection(bottomPageRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.2,
  });
  if (showHeader == '0px' || isDesktop) headerHidden.current = false;

  const breadCrumbsData = productData?.breadcrumb;
  let foot_note_description = productData.description;
  const product_nickname = productData?.nickname;
  const offer_strip_data = productData?.offerStrip;
  const isFertilityProduct = [3408, 3662, 3663].includes(productData?.id);

  let catDataSEO = '<h2><strong>Product Categories</strong></h2>';
  catDataSEO += catUrls?.reduce((acc, curr) => {
    acc += `<a href=${curr}>${getTitleFromUrl(curr, true)}</a>  |  `;
    return acc;
  }, '<p>');
  catDataSEO += '</p>';

  foot_note_description = catDataSEO + foot_note_description;
  if (checkShowFaqs(userType) && !isFertilityProduct)
    foot_note_description += getFaqsHtmlData(productData?.id);
  const offerData = getExperimentalOfferData(
    productId,
    updatedProductData?.data?.offers || [],
    userType,
  );
  const commonprops = {
    productData,
    setAddedToCart,
    priceData,
    // offerMutatedData,
    showLighteningDeal,
    setChangeCartCount,
    showTuesdayPopup,
    setShowTuesdayPopup,
    user_review_images,
    generalItemData,
  };
  useProductPageConstructor(productData, '');

  useEffect(() => {
    setChangeCartCount(false);
  }, [changeCartCount]);

  useEffect(() => {
    setAddedToCart(false);
  }, [addedToCart]);

  useEffect(() => {
    if (offer_strip_data) {
      updateOfferStripData(offer_strip_data);
      setChangeData(offer_strip_data);
    }
  }, [productData?.offerStrip]);

  useEffect(() => {
    document.documentElement.classList.remove('normal-scroll');
  }, [productApidata]);
  useEffect(() => {
    setUserType(getWebUserType());
    setExperimentUserType(getExperimentTypeOfUser());
    setVisitedCD(Boolean(Cookies.get('visitedCD')));
    if (productData.id === 979) {
      Cookies.set('recentProductId', productData.id, '/');
    } else {
      Cookies.remove('recentProductId', '/');
    }
    setCountry(getCountry());

    if (typeof window !== 'undefined' && isAndroidAppUser()) {
      setshowLoader(true);
      viewedAndroidLanding(productId);
      dynamicOpenDeepLink(
        '61',
        '/product/' + productId + window.location.search,
      );
    }
    oldScrollValue.current = window.pageYOffset;

    fireEvent({
      category: 'replace_all_available',
      value: String.prototype.replace ? true : false,
      screen_name: getScreenName(),
    });

    function scrollUpOrDown() {
      if (!throttleTimeout.current && !isDesktopUser()) {
        setTimeout(() => {
          let newValue = window.pageYOffset;
          if (oldScrollValue.current < newValue) {
            setCategoryNavBarTop(-19); //for Desktop screen
            if (newValue > 56) {
              setShowHeader('-56px'); // for Mweb
              setShowBreadCrumbs(true);
              setShowTop(true);
            }

            //on scroll down
          } else if (oldScrollValue.current > newValue) {
            setCategoryNavBarTop(56); // for Desktop screen
            setShowHeader('0px'); // for Mweb
            setShowTop(true);
            // on scroll up
          }
          oldScrollValue.current = newValue;
          throttleTimeout.current = false;
        }, 100);
      }
      throttleTimeout.current = true;
    }

    window.addEventListener('scroll', scrollUpOrDown);
    setShowTop(false);
    return () => {
      window.removeEventListener('scroll', scrollUpOrDown);
    };
  }, [productId]);

  useEffect(() => {
    if (
      bottomPageInteraction?.isIntersecting &&
      firedBottomPageEvent.current === false
    ) {
      fireScrollEvent('page_end', productData);
      firedBottomPageEvent.current = true;
    }
    if (isDesktopUser()) setShowHeader('0px');
  }, [bottomPageInteraction]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const RandomEventId = getRandomEventId();
    fbFixelTrackEvent(RandomEventId, productData?.id);
    fireConversionEvent(RandomEventId, productData?.id);
    const userType = getWebUserType();
    const apiParams = {
      product_id: productData?.id,
      type: params.get('type') || '',
      coupon: params.get('coupon') || '',
      newUser: !Cookies.get('shopper') ? true : undefined,
      userType: userType,
    };
    getPriceByType(apiParams);
    addProductToRecentltViewedSection(productData);

    fireUserLocationEvent(userType);
  }, [productData?.id]);

  const getPriceByType = async (apiParams) => {
    const productPriceFetcher = await getPriceFetcher();
    const updatedPrice = await productPriceFetcher(apiParams);
    Cookies.set('offer_user_type', updatedPrice?.error ? '' : apiParams?.type);
    const updatedData = JSON.parse(JSON.stringify(updatedProductData));
    if (updatedData?.data) {
      if (updatedPrice?.data?.dealName) setShowLighteningDeal(true);
      updatedData.data = { ...updatedData.data, ...updatedPrice.data };
    }
    productMutate(updatedData, false);
    setPriceData(true);
  };
  useEffect(() => {
    if (router.query['productImageGallery'] === 'true') {
      setShowHeader('-56px');
    }
  }, [router.query]);
  useEffect(() => {
    // Define your function to be called
    const fromReview = Cookies.get('fromReview');
    if (fromReview) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      Cookies.remove('fromReview');
    }
    const insTags = document.querySelectorAll('ins');

    // Remove each <ins> element
    insTags?.forEach((ins) => ins?.remove());
    const googleAd = document.querySelector('#google-anno-sa');
    googleAd?.remove();

    if (!isDesktopUser()) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      tag.onload = onYouTubeIframeAPIReady;
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      let player;

      function onYouTubeIframeAPIReady() {
        window.YT.ready(() => {
          if (videoRef.current) {
            player = new YT.Player(videoRef.current, {
              events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange,
              },
            });
          }
        });
      }

      function onPlayerStateChange(event) {
        if (event.data === YT.PlayerState.ENDED) {
          player.seekTo(0);
          player.playVideo();
        }
      }

      function onPlayerReady(event) {
        player?.pauseVideo();
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting)
              player?.playVideo(); // Play video when in view
            else player?.pauseVideo(); // Pause video when out of view
          });
        },
        {
          root: null, // Use viewport as root
          threshold: 0.5, // Play when 50% of the iframe is visible
        },
      );

      if (videoRef.current) observer.observe(videoRef.current); // Start observing the video element
      return () => {
        observer.disconnect(); // Clean up observer on component unmount
      };
    }
  }, []);
  if (!productApidata) {
    return <div></div>;
  }

  const floatingVideoData = productApidata.generalItemData.find(
    (item) => item.itemType == 'TYPE_REELS',
  );

  const addNddSddCard = async () => {
    const body = {
      productId: productId.toString(),
      totalOrderValue: productData?.price,
      webUserId: getWebUserId(),
      userType: getWebUserType(),
    };
    const resp = await checkProductSddNddEligiblity(body);
    if (resp?.data?.NddSddEligible) {
      setSddNddData(resp?.data);
      fireEvent({
        category: 'check_pincode_for_sdd',
        parent: productId,
      });
    }
  };

  useEffect(() => {
    addNddSddCard();
    const buyAgain = Cookies.get('buy_again_product');
    if (buyAgain === 'true') {
      productActionClick('buyNow', productData, '');
    }
    Cookies.remove('buy_again_product');
  }, [productData?.id]);

  useEffect(() => {
    if (!getUserIsLoggedIn() && showHeader == '0px') {
      const showKwikPassSsoTooltip = checkEligibilityForSsoTooltip();
      setShowSsoTooltip(showKwikPassSsoTooltip);
    } else {
      setShowSsoTooltip(false);
    }
  }, [getUserIsLoggedIn(), showHeader]);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        if (showSsoTooltip) {
          setShowSsoTooltipDot(true);
        }
        setShowSsoTooltip(false);
      } else if (currentScrollY < lastScrollY || currentScrollY <= 50) {
        setShowSsoTooltip(true);
        setShowSsoTooltipDot(false);
      }

      lastScrollY = currentScrollY;
    };
    if (
      getUserIsLoggedIn() ||
      !checkEligibilityForSsoTooltip() ||
      showHeader != '0px'
    ) {
      setShowSsoTooltip(false);
    } else {
      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showSsoTooltip]);

  const openLoginPopUp = () => {
    setLoginPopUp(true);
  };

  return (
    <>
      <PDPHeadElements
        productData={productData}
        ReviewJSONLDData={ReviewJSONLDData}
        DiscussionJSONLDData={DiscussionJSONLDData}
        userType={userType}
        breadCrumbsData={breadCrumbsData}
        fromOriginalPdp={true}
        offerData={offerData}
      />
      {showLoader && <Loader />}
      <>
        <GlobalStyle />
        <ImageGalleryStyle />

        <NewHeader
          showOldSubHeader={true}
          hideLogin={country === 'uae'}
          categoryData={categoryData}
          addedToCart={addedToCart}
          showCart={true}
          showTrackOrder={true}
          categoryNavBarTop={categoryNavBarTop}
          location={'PDP'}
          showHeader={showHeader}
          setAddedToCart={setAddedToCart}
          hideCompleteHeader={headerHidden.current}
          productId={productId}
          setIsCartOpen={setIsCartOpen}
          showSsoTooltipDot={showSsoTooltipDot}
          loginPopUp={loginPopUp}
          setLoginPopUp={setLoginPopUp}
        />
        <OfferStripHeader
          showHeader={showHeader}
          pdp={true}
          sticky={true}
          offerData={offerData}
          isDiaperSku={
            diaperSkus.includes(Number(productId)) &&
            visitedCD &&
            showDiaperSwitch(userType)
          }
          showNewUi={showNewOfferStripUI}
          bgColor={showNewOfferStripUI ? '#11a5dd' : ''}
          textColor={showNewOfferStripUI ? '#fff' : ''}
        />
        <SVGSourcePDP />

        <KwikPassSsoTooltip
          setShowSsoTooltip={setShowSsoTooltip}
          fromPdp={true}
          showSsoTooltip={showSsoTooltip}
          openLoginPopUp={openLoginPopUp}
        />

        <MainContainer
          showHeader={showHeader}
          paddingTop={'180px'}
          pdpHideHeader={!showTop}
          isDiaperSku={
            diaperSkus.includes(Number(productId)) &&
            visitedCD &&
            showDiaperSwitch(userType)
          }
        >
          {breadCrumbsData?.length ? (
            <BreadcrumbsCover showBreadCrumbs={showBreadCrumbs}>
              <Breadcrumbs breadCrumbs={breadCrumbsData} />
            </BreadcrumbsCover>
          ) : null}
          <WidgetsMerge
            offerList={offerData}
            {...commonprops}
            userType={userType}
            experimentUserType={experimentUserType}
            videoRef={videoRef}
            isFullScreenVideoEnabled={isFullScreenVideoEnabled}
            setCurrentVideoIndex={setCurrentVideoIndex}
            setIsFullScreenVideoEnabled={setIsFullScreenVideoEnabled}
            setShowFullScreenVideo={setShowFullScreenVideo}
            sddNddData={sddNddData}
          />
          {floatingVideoData?.items?.length && isVideoVisible && (
            <FloatingVideo
              multipleVideos={floatingVideoData?.items}
              setIsFullScreenVideoEnabled={setIsFullScreenVideoEnabled}
              isForLactoPage={true}
              fromPdp={true}
              isCartOpen={isCartOpen}
              currentVideoIndex={currentVideoIndex}
              showFullScreenVideo={showFullScreenVideo}
              setShowFullScreenVideo={setShowFullScreenVideo}
              setCurrentVideoIndex={setCurrentVideoIndex}
            />
          )}
        </MainContainer>
        <div ref={bottomPageRef}></div>
        <NewFooter
          screen={'pdp'}
          content={foot_note_description}
          showHeader={showHeader}
          heading={product_nickname}
          priceTable={productData?.id == 283 ? lotionFootnoteTable : null}
          ratingTable={productData?.id == 283 ? ratingTableLotion : null}
          productId={productId}
        />
      </>
    </>
  );
}
